import { GetLicensingMarkQueryVariables } from '@app/data/shop-bff';
import { publicShopBffSdk } from '@app/utils/common';
import { useCallback, useState } from 'react';
import { LicensingMark } from './types';

export const useLicensingMarks = () => {
  const [{ licensingMarks, loading }, setLicensingMark] = useState<{
    licensingMarks: LicensingMark[];
    loading: boolean;
  }>({
    licensingMarks: [],
    loading: true,
  });

  const refresh = useCallback((variables: GetLicensingMarkQueryVariables) => {
    setLicensingMark({ licensingMarks: [], loading: true });

    publicShopBffSdk
      .GetLicensingMark(variables)
      .then((res) => {
        setLicensingMark({
          licensingMarks: res.shop_licensingMarks,
          loading: false,
        });
      })
      .catch(() => {
        // TODO: Handle errors
        setLicensingMark({
          licensingMarks: [],
          loading: false,
        });
      });
  }, []);

  return {
    licensingMarks,
    loading,
    refresh,
  };
};
